import axios from "@app/Security/AxiosAuthentication";
import DashboardNewsInterface from "@app/Interface/DashboardNewsInterface"
import ApiEndpoints from "@app/utils/ApiEndpoints";
import DashboardNewsModel from "@app/Model/DashboardNewsModel";
import ArticleHelper from "./ArticleHelper";
import EventInterface from "@app/Interface/EventInterface";
import DashboardDataInterface from "@app/Interface/DashboardDataInterface";
import DashboardDataModel from "@app/Model/DashboardDataModel";
import htmlParser from "@app/utils/htmlParser";
import ErrorResponseInterface from "@app/Interface/ErrorResponseInterface";
import ApiCache from "./ApiCache";
import AppSettings from "@app/utils/AppSettings";

export default class DashboardHelper {

    static getDashboardNews = async (controller: AbortController, fpuId: number, articlePageId: number, articleLimit: number, eventsPageId: number, eventsLimit: number): Promise<DashboardNewsInterface> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.DASHBOARD_NEWS + `?page=1&articles_limit=${articleLimit}&articles_page_id=${articlePageId}&events_limit=${eventsLimit}&events_page_id=${eventsPageId}&fpu=${fpuId}`;

        const url = baseUrl + endPoint;

        const config = {
            withCredentials: true,
            signal: controller.signal
        };

        // TODO: Try adding caching news later
        // const cacheData = ApiCache.get(url);

        // if (cacheData) {
        //     const cachedPageData: DashboardNewsInterface = JSON.parse(cacheData.content);

        //     return cachedPageData;
        // }

        try {

            const response = await axios.get(url, config);

            // Api Platform updated how collection routes need to return data, a plain object does not cut it anymore
            const data: DashboardNewsInterface = response.data['hydra:member'][0];

            // format the articles
            const articles = ArticleHelper.getArticleItemsFromResponseData(data.articles);

            data.articles = articles;

            // format the events
            const events = DashboardHelper.getFormattedEvents(data.events);

            data.events = events;

            // save to cache
            ApiCache.set(url, data, AppSettings.getPageCacheStaleMinutes());

            return data;


        } catch (error) {

            // TODO: replace with rollbar
            console.group("getDashboardNews");
            console.info("url: ", url);
            console.info("error: ", error);
            console.groupEnd();

            // return empty data
            const data = new DashboardNewsModel();

            return data;

        }

    }

    static getDashboardNewsNonAsync = (fpuId: number, articlePageId: number, articleLimit: number, eventsPageId: number, eventsLimit: number): void => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.DASHBOARD_NEWS + `?page=1&articles_limit=${articleLimit}&articles_page_id=${articlePageId}&events_limit=${eventsLimit}&events_page_id=${eventsPageId}&fpu=${fpuId}`;

        const url = baseUrl + endPoint;

        const config = {
            withCredentials: true
        };

        axios.get(url, config)
            .then(response => {

                const data: DashboardNewsInterface = response.data;

                // format the articles
                const articles = ArticleHelper.getArticleItemsFromResponseData(data.articles);

                data.articles = articles;

                // format the events
                const events = DashboardHelper.getFormattedEvents(data.events);

                data.events = events;

                // save to cache
                ApiCache.set(url, data, AppSettings.getPageCacheStaleMinutes());

            })
            .catch(error => {

                // TODO: replace with rollbar
                console.group("getDashboardNews");
                console.info("url: ", url);
                console.info("error: ", error);
                console.groupEnd();

            });

    }

    static getFormattedEvents = (rawEvents: EventInterface[] | ErrorResponseInterface): EventInterface[] => {

        let fetchedEvents: EventInterface[] = [];

        if (Array.isArray(rawEvents)) {

            fetchedEvents = rawEvents.map(event => {
                return {
                    id: event.id,
                    slug: event.slug,
                    title: htmlParser.htmlDecode(event.title),
                    content: event.content,
                    eventLocation: event.eventLocation ?? null,
                    eventStartDate: new Date(event.eventStartDate),
                    eventEndDate: !event.eventAllDay && event.eventEndDate ? new Date(event.eventEndDate) : null,
                    eventAllDay: event.eventAllDay
                };
            });

        }

        return fetchedEvents;

    }

    static getDashboardData = async (controller: AbortController, currentComponentPageId: number, qualityComponentsPageId: number, componentsLimit: number, coopPageId: number, montanaPageId: number, fpuId: number): Promise<DashboardDataInterface> => {

        const currentDate = new Date();

        const pickupStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

        const startDateString = pickupStartDate.toISOString();

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.DASHBOARD_DATA + `?page=1&current-component-page-id=${currentComponentPageId}&quality-components-page-id=${qualityComponentsPageId}&coop-page-id=${coopPageId}&montana-page-id=${montanaPageId}&pickup_date_start=${startDateString}&components_limit=${componentsLimit}&fpu=${fpuId}`;

        const url = baseUrl + endPoint;

        const config = {
            withCredentials: true,
            signal: controller.signal
        };

        try {

            const response = await axios.get(url, config);

            // Api Platform updated how collection routes need to return data, a plain object does not cut it anymore
            const data: DashboardDataInterface = response.data['hydra:member'][0];

            return data;


        } catch (error) {

            // TODO: replace with rollbar
            console.group("getDashboardData");
            console.info("url: ", url);
            console.info("error: ", error);
            console.groupEnd();

            // return empty data
            const data = new DashboardDataModel();

            return data;

        }

    }

}